import { useState, useMemo, useEffect } from 'react'
import { Box, Slider, Typography, TextField } from '@mui/material'

const TIERS = [
  { cap: 2500, price: 10 },
  { cap: 5000, price: 17.5 },
  { cap: 10000, price: 30 },
  { cap: 50000, price: 125 },
  { cap: 100000, price: 200 },
  { cap: 250000, price: 375 },
  { cap: 500000, price: 625 },
  { cap: 1000000, price: 1000 },
]

function calcPrice(credits, period = 'monthly') {
  const tier = TIERS.find(t => credits <= t.cap) || TIERS.at(-1)
  const rate = tier.price / tier.cap
  let total = +(credits * rate).toFixed(2)

  if (period === 'yearly') total = +(total * 12 * 0.8).toFixed(2)
  return total
}

export default function AddCreditsSlider({ onPriceChange, period = 'monthly' }) {
  const [credits, setCredits] = useState(2500)
  const price = useMemo(() => calcPrice(credits, period), [credits, period])

  const marks = [
    { value: 2500, label: '2.5K' },
    { value: 100000, label: '100K' },
    { value: 500000, label: '500K' },
    { value: 1000000, label: '1M' },
  ]

  useEffect(() => {
    onPriceChange({ credits, period, price })
  }, [credits, period, price, onPriceChange])

  return (
    <Box p={2}>
      <Typography variant='h6' gutterBottom>
        Add Email Verification Credits
      </Typography>

      <Slider
        aria-label='Credits'
        value={credits}
        min={2500}
        max={1000000}
        step={2500}
        marks={marks}
        valueLabelDisplay='auto'
        valueLabelFormat={v => v.toLocaleString('en-US')}
        onChange={(_, v) => setCredits(v)}
      />

      <TextField
        type='number'
        inputProps={{ step: 2500, min: 2500, max: 1000000 }}
        label='Credits'
        value={credits}
        onChange={e =>
          setCredits(Math.min(1000000, Math.max(2500, Math.round(Number(e.target.value) / 2500) * 2500)))
        }
        sx={{ mt: 2 }}
        fullWidth
      />

      <Typography variant='subtitle1' sx={{ mt: 2 }}>
        {credits.toLocaleString()} credits →{' '}
        <strong>${price.toLocaleString()}</strong> {period === 'yearly' ? 'per year' : 'this month'}
      </Typography>
    </Box>
  )
}